module.exports = __webpack_public_path__ + "img/sign-12.7c7694cb.jpg";